// IMPORTANT:
// Do not use/extend this file anymore. It is only here for historical reasons and to support some web components we are still using in the experience editor. 
// Please use src/index-booker.js instead.

import "preact/debug";
import {h, render} from 'preact';
import { createRef } from 'preact/compat';
import register from 'preact-custom-element';
import './main.css';

import ImageBannerNavigation from "./stories/components/ImageBannerNavigation/ImageBannerNavigation";
import NavigationCard from "./stories/components/NavigationCard/NavigationCard";
import { ArticleImage } from './stories/pages/Article/components/ArticleImage';
import { ArticleQuote } from './stories/pages/Article/components/ArticleQuote';
import { ArticleShare } from './stories/pages/Article/components/ArticleShare';

register(ImageBannerNavigation, 'b-imagebannernavigation', ['imagedesktop', 'imagemobile', 'bannertitle', 'bannerdescription', 'cardstitle', 'classname'])
register(NavigationCard, 'b-navigationcard', [])
register(ArticleImage, 'b-articleimage', ['image', 'alt'])
register(ArticleQuote, 'b-articlequote', ['text'])
register(ArticleShare, 'b-articleshare', ['handleOnClick'])

// Do not remove this registration as it makes sures some styles are included in styles.css that are necessary for the Hero component to work correctly 
import Hero from './stories/components/Hero/Hero';
register(Hero, 'b-hero', ['title', 'description', 'image', 'classname'])

